import React, { useEffect } from "react";
import { useApp } from "../../contexts";
import useSsoShopifyUrl from "../../hook/useSsoShopifyUrl";
import { getCookie } from "../../utils/helper";
import { KEY_COOKIE } from "../../constants";

export const ItemEarnBig = ({ value, ...props }) => {
  const { T, user, setLoading, language } = useApp();
  const { className, title, description } = props;

  const { shopifyUrl, isLoading: isHandlingShopifyUrl } = useSsoShopifyUrl({
    token: getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.access_token ?? "",
    storeShopifyUrl: user?.store_shopify,
    query: {
      lang: user?.language,
    },
  });

  useEffect(() => {
    if (isHandlingShopifyUrl) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isHandlingShopifyUrl]);

  return (
    <div className={`w-full ${className}`}>
      <div
        className="text-white font-semibold text-[20px]/[24px] xl:text-[32px]/[45px] 2xl:text-[37px]/[50px] xl:w-[280px] 2xl:w-[350px] lg:w-[250px] md:w-[200px] w-[200px] drop-shadow"
        dangerouslySetInnerHTML={{
          __html: T(title),
        }}
      ></div>
      <div
        className={`w-[200px] md:w-[200px] lg:w-[250px] xl:w-[250px] 3xl:w-[300px] text-white font-semibold ${language === 'pt' ? 'xs:text-[12px]/[18px]  sm:text-[14px]/[20px]' : 'text-[14px]/[20px]'} description drop-shadow`}
        dangerouslySetInnerHTML={{
          __html: T(description),
        }}
      ></div>
      <div className={`flex justify-start lg:mt-4 items-center gap-4`}>
        <button
          className="earn-big-btn"
          onClick={() => {
            let windowReference = window.open();
            shopifyUrl((url) => {
              if (windowReference) {
                windowReference.location = new URL(url);
              }
            });
          }}
        >
          {T("Buy Art Now")}
        </button>
      </div>
    </div>
  );
};
